import React from "react";
import { useSimulationStore } from "../../store/simulationStore";
import { TIME_SCALE_OPTIONS } from "../../store/simulationStore";
import { celestialBodyCatalog } from "../../data/catalog";
import { describeScale } from "../../utils/scaling";

export function SimulationInfoPanel() {
  const isPlaying = useSimulationStore((s) => s.isPlaying);
  const timeScale = useSimulationStore((s) => s.timeScale);
  const precisionMode = useSimulationStore((s) => s.precisionMode);
  const label =
    TIME_SCALE_OPTIONS.find((o) => o.value === timeScale)?.label ??
    `${timeScale}x`;

  return (
    <aside className="tls-astro-panel tls-astro-panel-secondary">
      <h3>Simulação</h3>
      <ul className="tls-astro-list">
        <li>Corpos: {celestialBodyCatalog.length}</li>
        <li>
          Luas catalogadas:{" "}
          {celestialBodyCatalog.filter((b) => b.type === "moon").length}
        </li>
        <li>Estado: {isPlaying ? "reproduzindo" : "pausado"}</li>
        <li>Velocidade: {label}</li>
        <li>Modo: {precisionMode}</li>
        <li>{describeScale()}</li>
      </ul>
    </aside>
  );
}
